module.exports = __webpack_public_path__ + "static/media/cold_1.8ac72469.png";